// eslint-disable-next-line import/prefer-default-export
export const remCalc = (px) => `${px / 16}rem`
